import React from 'react';
import clsx from 'clsx';
import Tooltip from '../../../../common/_custom/Tooltip/Tooltip';
import styles from './DebtOptionTag.module.scss';
import { DebtOptionTagProps, DebtOptionTagType } from '../../debtProductTypes';
import { DEBT_OPTION_TAG, DEBT_OPTION_TAG_CONFIG, DEBT_OPTION_TAG_NORMALIZE_MAP } from '../../DebtProductsConstants';
import { COLORS } from '../../../../utils/constants/colors';

const TAG_STYLE_MAP: Record<DebtOptionTagType, string> = {
    [DEBT_OPTION_TAG.REQUESTED]: styles.RequestedTag,
    [DEBT_OPTION_TAG.PREFERRED]: styles.PreferredTag,
    [DEBT_OPTION_TAG.EXCLUDED]: styles.ExcludedTag,
};

function normalizeTagKey(tag: string): DebtOptionTagType | null {
    if (typeof tag !== 'string' || !tag.trim()) return null;
    const upper = tag.trim().toUpperCase().replace(/\s+/g, ' ');
    return DEBT_OPTION_TAG_NORMALIZE_MAP[upper] ?? null;
}

function getTagLabel(key: DebtOptionTagType, labelText: string): React.ReactNode {
    switch (key) {
        case DEBT_OPTION_TAG.PREFERRED:
            return <span className={styles.PreferredTagText}>{labelText}</span>;
        case DEBT_OPTION_TAG.REQUESTED:
        case DEBT_OPTION_TAG.EXCLUDED:
        default:
            return labelText;
    }
}

const DebtOptionTag: React.FC<DebtOptionTagProps> = ({ tag }) => {
    const key = normalizeTagKey(tag);
    if (!key) return null;

    const config = DEBT_OPTION_TAG_CONFIG[key];
    const className = TAG_STYLE_MAP[key];
    const label = getTagLabel(key, config.label);
    const pill = <span className={clsx(styles.TagPill, className)}>{label}</span>;

    if (!config.tooltip) return pill;
    return (
        <Tooltip content={config.tooltip} direction="top" fitContent usePortal={true} contentCss={{ color: COLORS.DARK_GREY }}>
            {pill}
        </Tooltip>
    );
};

export default DebtOptionTag;
